import { createInstance, Resource, i18n } from 'i18next';
import { initReactI18next } from 'react-i18next/initReactI18next';
import resourcesToBackend from 'i18next-resources-to-backend';

import { getCountryConfig } from '@/app/utils/countryConfig';
import { Language } from '@/app/enums';

const countryConfig = getCountryConfig();

export const fallbackLng = countryConfig.fallbackLanguage;

export const supportedLanguages = [fallbackLng, Language.EN];

export const i18nConfig = {
  locales: supportedLanguages,
  defaultLocale: fallbackLng,
};

export const supportedLanguage = {
  FALLBACK: countryConfig.fallbackLanguage,
  ENGLISH: 'en',
} as const;

export const validateLocale = (locale?: string | null): Language => {
  if (supportedLanguages.includes(locale as Language)) {
    return locale as Language;
  }
  return fallbackLng as Language;
};

export const initTranslations = async (
  locale?: string,
  namespaces: string[] = ['common'],
  i18nInstance?: i18n,
  resources?: Resource,
) => {
  const parsedLng = validateLocale(locale);

  i18nInstance = i18nInstance || (createInstance() as i18n);

  i18nInstance.use(initReactI18next);

  if (!resources) {
    i18nInstance.use(
      resourcesToBackend(
        (language: string, namespace: string) => import(`@/app/locales/${language}/${namespace}.json`),
      ),
    );
  }

  await i18nInstance.init({
    lng: parsedLng,
    resources,
    fallbackLng: i18nConfig.defaultLocale,
    supportedLngs: i18nConfig.locales,
    defaultNS: namespaces[0],
    fallbackNS: namespaces[0],
    ns: namespaces,
    preload: resources ? [] : i18nConfig.locales,
  });

  return {
    i18n: i18nInstance,
    resources: i18nInstance.services.resourceStore.data,
    t: i18nInstance.t,
  };
};
